module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n<pioneer-iata-by-default-modal\n  data-se-id=\"app-component-iata-by-default-modal\">\n</pioneer-iata-by-default-modal>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/secured-home/secured-home.component.html
// module id = kt5u
// module chunks = 0